export class OfferProcureShipRfqManager {

    constructor(private containerElement: JQuery) { }

    private linkSwitchInputs : JQuery<Element>;

    public initialize() {
        this.initializeStatusSwitch();
    }

    private initializeStatusSwitch() {
        this.linkSwitchInputs = this.containerElement.find('#rfq-status-toggle input');

        var acceptContainer = this.containerElement.find('#accept-rfq-items-container');
        var declineContainer = this.containerElement.find('#decline-rfq-items-container');

        this.linkSwitchInputs.off('click').on('click', function() {
            var selectedLinkType : string = $(this).val().toString();   

            acceptContainer.addClass("d-none");
            declineContainer.addClass("d-none");

            if(selectedLinkType == "RFQAccepted") {
                acceptContainer.removeClass("d-none");
            }
            else if(selectedLinkType == "RFQNotAccepted") {
                declineContainer.removeClass("d-none");
            }
        }); 

        this.containerElement.find('#rfq-status-toggle input input:checked').trigger('click');
    }
}